import React from 'react'
import { useToastContext } from '../../context/ToastContext'

const variantStyles = {
  success: 'bg-success text-white',
  error: 'bg-error text-white',
  warning: 'bg-warning text-white',
  info: 'bg-info text-white',
}

/**
 * Fixed-position toast notification stack.
 * Render once inside Layout — notifictions are fired via useToast().
 */
export default function Toast() {
  const { toasts } = useToastContext()

  if (!toasts.length) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      {toasts.map(t => (
        <div
          key={t.id}
          role="alert"
          className={`rounded-lg px-4 py-3 shadow-lg text-sm font-medium pointer-events-auto transition-all ${variantStyles[t.variant] || variantStyles.info}`}
        >
          {t.message}
        </div>
      ))}
    </div>
  )
}
